/*
 * Copyright (c) 2024. Dave van Rijn Development
 */
import './style/pdfElementSettings.scss';

import React, {MouseEventHandler, PureComponent} from 'react';
import {PdfElement} from "../element/pdfElement";
import PdfText from "../text/pdfText";
import {ChangeFunction, PDFElementPersist, PdfFont, PDFTextVariables} from "../../util/interfaces";
import {fontItems, showDialog, stopPropagation} from "../../../../";
import PdfTextSettings from "./text/pdfTextSettings";
import PdfImage from "../image/pdfImage";
import PdfImageSettings from "./image/pdfImageSettings";
import PdfInvoiceTable from "../invoiceTable/pdfInvoiceTable";
import PdfInvoiceTableSettings from "./invoiceTable/pdfInvoiceTableSettings";
import DvrdButton from "../../button/dvrdButton";
import DvrdSelect from '../../select/dvrdSelectController';

interface Props {
    onReset: MouseEventHandler;
    onChangeFont: ChangeFunction;
    element: PdfElement | null;
    customVariables?: PDFTextVariables;
    font: PdfFont;
    supportMultiPage: boolean;
    enableTableHeaderColor?: boolean;
}

export default class PdfElementSettings extends PureComponent<Props> {
    onClickDelete = (evt: React.MouseEvent) => {
        const {element} = this.props;
        if (element) {
            const persistence: PDFElementPersist = element.isPersistent();
            if (persistence === PDFElementPersist.PERSISTENT) return;
            else if (persistence === PDFElementPersist.CONFIRM) {
                showDialog('We raden aan om dit element wel te tonen op de factuur. Weet je zeker dat je dit ' +
                    'element wilt verwijderen?', 'Element verwijderen',
                    ['Nee', {label: 'Ja', onClick: element.onClickDelete}]);
            } else element.onClickDelete(evt);
        }
    };

    getTitle = (): string => {
        const {element} = this.props;
        if (element instanceof PdfText) return 'Tekst opties';
        if (element instanceof PdfImage) return 'Afbeelding opties';
        if (element instanceof PdfInvoiceTable) return 'Factuurregel opties';
        return 'Opties'
    };

    renderSettings = () => {
        const {element, customVariables, supportMultiPage, enableTableHeaderColor} = this.props;
        if (element === null) return this.renderMainSettings();
        if (element instanceof PdfText) return <PdfTextSettings element={element} customVariables={customVariables}
                                                                supportMultiPage={supportMultiPage}/>;
        if (element instanceof PdfImage) return <PdfImageSettings element={element}
                                                                  supportMultiPage={supportMultiPage}/>;
        if (element instanceof PdfInvoiceTable) return <PdfInvoiceTableSettings element={element}
                                                                                headColorEnabled={enableTableHeaderColor}/>
        return null;
    };

    renderMainSettings = () => {
        const {font, onChangeFont} = this.props;
        return (
            <div className='main-settings'>
                <DvrdSelect items={fontItems} value={font} onChange={onChangeFont} label='Standaard lettertype'
                            unControlled/>
            </div>
        )
    };

    render = () => {
        const {element, onReset} = this.props, deleteAble = element?.isPersistent() !== PDFElementPersist.PERSISTENT;
        return (
            <div className='pdf-element-settings' onClick={stopPropagation}>
                <h2 className='settings-title'>{this.getTitle()}</h2>
                {!element && <label className='empty-label'>Selecteer een element om opties te weergeven</label>}
                {this.renderSettings()}
                {element !== null && (
                    <div className='buttons-container'>
                        <DvrdButton onClick={onReset} label='Oké' className='reset-btn'/>
                        {deleteAble &&
                            <DvrdButton onClick={this.onClickDelete} label='Verwijderen' customContrastColor='red'
                                        secondary/>}
                    </div>
                )}
            </div>
        );
    }
};